import React from 'react';
import Modal from 'react-bootstrap/Modal';

import { ModalContainer } from 'pages/DrLicitaPeticoes/styles';

// Modal de confirmação de exclusão do Dr. Licita 3.0 — segue o padrão de
// modais da plataforma (bootstrap: modal-header/close/btn), substituindo o
// window.confirm nativo.

interface DrLicitaConfirmProps {
  titulo: string;
  mensagem: string;
  onCancelar: () => void;
  onConfirmar: () => void;
}

const DrLicitaConfirm = ({ titulo, mensagem, onCancelar, onConfirmar }: DrLicitaConfirmProps) => (
  <Modal show centered onHide={onCancelar}>
    <ModalContainer>
      <div className="modal-header">
        <h5 className="modal-title text-nowrap">
          <strong>{titulo}</strong>
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={onCancelar}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        <p className="text-center mb-0 py-3">{mensagem}</p>
      </div>
      <div className="modal-footer justify-content-center">
        <button type="button" className="btn btn-sm btn-light border" onClick={onCancelar}>
          Cancelar
        </button>
        <button type="button" className="btn btn-sm btn-danger" onClick={onConfirmar}>
          Excluir
        </button>
      </div>
    </ModalContainer>
  </Modal>
);

export default DrLicitaConfirm;
